import React, { useEffect, useState } from 'react'
import { revertQuantity } from '../../HelperFunctions'
import { ViewAlts } from '../../CustomizeOrder'
import { AjaxPost } from "../../../../Services/index";
import { CloseButton } from '../../Modals/AddToCartModal'

export const OnAllocationModal = ({ updateCart, setUpdateCart, setItems }) => {
    if (updateCart?.RestrictionTypes?.includes('OnAllocation') || updateCart?.RestrictionTypes?.includes('OnBackorder')) {
        let itemsListOver = [], itemsListNotTaking = [];
        const [result, setResult] = useState(null);

        useEffect(() => setItems([...updateCart.ItemList]), []);

        return (<>
            <div id='onallocation-modal' className="tw-flex tw-relative tw-flex-col sm:tw-w-[511px] tw-bg-white" onClick={hideModals}>
                <div className="tk-trade-gothic-next tw-text-mine-shaft-950 tw-flex tw-flex-col ">
                    <CloseButton updateCart={updateCart} setUpdateCart={setUpdateCart} />
                    <div className="tw-mx-[16px] sm:tw-mx-[24px] tw-p-[1rem] tw-pb-[0.5rem] tw-pl-0" style={{ borderBottom: "1.5px solid #282828" }} >
                        <h5 className="modal-title tw-flex tw-gap-[6px] tw-font-bold tw-text-[22px] tw-text-left">
                            Cart Notification
                        </h5>
                    </div>
                    <div className="tw-px-[16px] sm:tw-px-[26px] tw-pt-[0.6rem] tw-relative">
                        <div className="tw-mb-[2px] tw-text-tamarillo-700 tw-px-[8px] tw-font-bold tw-text-[14px]">
                            Out of Stock:
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-[8px] tw-pb-[12px] tw-px-[8px] tw-overflow-auto tw-max-h-[108px]"
                            style={{ borderBottom: '1px solid #A2A2A2' }}>
                            {updateCart.ItemList.map((item, i) => {
                                return (
                                    item.UoMPrices.some(uom => uom.MessageCode === 'OnAllocation' || uom.MessageCode === 'OnBackorder') &&
                                    <div key={`allocation-item-${i}`} className="tw-flex tw-gap-[36px] tw-items-center"
                                        style={i !== 0 ? { borderTop: "1px solid #A2A2A2", paddingTop: "6px" } : {}}>
                                        <div className="tw-flex tw-flex-col tw-gap-[6px]">
                                            {item.UoMPrices.map((uom, j) => {
                                                if (uom.MessageCode === 'OnAllocation' || uom.MessageCode === 'OnBackorder') {
                                                    const [itemName, description] = !!item.SDname ? item.SDname.split(',') : ['N/A', 'N/A'];
                                                    if (uom.MessageCode === 'OnAllocation') itemsListOver.push(item);
                                                    if (uom.MessageCode === 'OnBackorder') itemsListNotTaking.push(item);
                                                    useEffect(() => revertQuantity(updateCart, i, j), []);
                                                    return (
                                                        <div key={`allocation-uom-${j}`} className="tw-flex tw-gap-[26px] tw-items-center" >
                                                            <div className="tw-leading-[15px] tw-text-[14px]">
                                                                <div>{uom.ItemID}</div>
                                                                <div className="tw-font-bold">{itemName},&nbsp;{description}</div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                        <ViewAlts item={item} mainWindow={false} />
                                    </div>
                                )
                            })}
                        </div>
                        <div className="tw-mt-[16px] tw-mb-[14px] tw-px-[8px] tw-font-bold tw-leading-[18px]">
                            <div className="tw-text-[14px]">Notify me when available</div>
                            <div className="tw-text-[13px]">We'll notify you when this product is back in stock.</div>
                        </div>

                        <div className={"tw-relative " + (result !== null && "tw-pointer-events-none tw-opacity-50")}>
                            <div className="tw-px-[18px] tw-pt-[14px] tw-pb-[26px] tw-bg-[#F0F0F0] tw-flex tw-flex-col tw-gap-[4px] tw-mb-[8px]">
                                <div className="tw-flex tw-flex-col">
                                    <label className="tw-text-[14px] tw-italic">
                                        Comments (if including more products, please add quantities and sizes you are in search of)
                                    </label>
                                    <textarea className="tw-resize-none tw-h-[150px] tw-text-[14px]" name="allocation-comment" maxLength="800" />
                                </div>
                            </div>
                            <div className="tw-cursor-pointer tw-w-full tw-h-[36px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[13px]"
                                onClick={sendEmail}> Notify Me
                            </div>
                            {result === 0 &&
                                <div id="AnimationContainer" className="tw-absolute tw-top-0 tw-bottom-0 tw-right-0 tw-left-0 tw-text-center tw-content-evenly">
                                    <i className="fas fa-spinner fa-spin" id="SpinnerAnimation"></i>
                                </div>}
                        </div>
                        {result === 1
                            ? <div className="tw-mt-[18px] tw-text-[14px] tw-text-[#62A94B]">
                                You will be notified as soon as the requested products are back in stock.
                                Click <a className="tw-font-bold tw-text-[#62A94B]" onClick={() => setUpdateCart(null)}>here</a> to close this window.
                            </div>
                            : result === -1
                                ? <div className="tw-mt-[18px] tw-text-[14px] tw-text-tamarillo-700">
                                    There was an error sending your request. Please contact us if this issue persists.
                                    Click <a className="tw-font-bold tw-text-tamarillo-700" onClick={() => setUpdateCart(null)}>here</a> to close this window.
                                </div>
                                : null}
                    </div>
                    <div className="tw-flex tw-flex-col tw-border-none tw-pb-[24px] tw-justify-left tw-leading-[17px] tw-text-[13px] tw-mt-[18px] tw-pl-[18px] sm:tw-pl-[34px]">
                        <div className="tw-font-bold">Customer Care</div>
                        <div>Customercare@life-assist.com</div>
                        <div>800-824-6016</div>
                    </div>
                </div>
            </div>
        </>)

        function sendEmail() {
            setResult(0);
            let payload = {
                Comment: $('textarea[name="allocation-comment"]').val(),
                ProductURL: window.location.href,
                //TODO Refactor away the distinction of ItemIDs when the shopping cart is refactored.
                ItemsListOver: [...new Map(itemsListOver.map(item => [item['ItemID'], item])).values()],
                ItemsListNotTaking: [...new Map(itemsListNotTaking.map(item => [item['ItemID'], item])).values()]
            }
            new AjaxPost({
                endpoint: '/ShoppingCart/SendAllocationEmail',
                payload: JSON.stringify(ko.toJS(payload)),
                cbFunction: () => setResult(1),
                errFunction: () => setResult(-1)
            });
        }

        function hideModals(e) {
            if ($(e.target).hasClass('view-alternatives')) return;
            $('.group-hover').hide()
        }
    }
}